import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { SnowplowService } from 'wanderu-service-analytics';
import WapiService from 'wanderu-service-wapi';

import { actions as userInfoActions } from '../../appstate/userInfo';
import { logInAction } from '../logIn';
import { actions } from './base';

const logger = Logger.getLogger('wanderu-ducks-account');

function reset() {
    return actions.reset();
}

async function postReferredSignUpEvent(referralCode) {
    try {
        await WapiService.post('events.json', {
            body: {
                event: 'user:action:referredSignUp',
                data: {
                    referralCode,
                },
                event_timestamp: Date.now(),
            },
        });
    } catch (ex) {
        const domainUserInfo = appSettings.env.isClient
            ? SnowplowService.getDomainUserInfo()
            : {};

        logger.error('postReferredSignUpEvent', ex, {
            snowplowIds: {
                networkUserId: SnowplowService.getNetworkUserId(),
                ...domainUserInfo,
            },
        });
    }
}

function createAccountAndLogIn(accountInfo) {
    return async (dispatch) => {
        dispatch(actions.startWork());

        const {
            email,
            password,
            referralCode,
        } = accountInfo;

        let error;
        let meta;
        try {
            await AccountService.createAccount(accountInfo);
            await dispatch(logInAction.cognitoLogIn(email, password));
            if (referralCode) {
                await postReferredSignUpEvent(referralCode);
            }
            // Mark as new account after log in b/c there is a data reconcilation process
            // during login
            dispatch(userInfoActions.markAsNewAccount());
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('createAccountAndLogIn', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(meta, error));
        }
    };
}

export {
    createAccountAndLogIn,
    reset,
};
